import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "all-reviews-desktop" */ './ReviewList'));
